// extracted by mini-css-extract-plugin
export default {"card":"Card_card__i4ZK6","imageMask":"Card_imageMask__Tifr9","number":"Card_number__tKMM3"};